import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../store";

const AuthProtected = (props) => {
  const authState = useSelector((state: RootState) => state.auth.token);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (authState !== undefined) {
      setIsLoading(false);
    }
  }, [authState]);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!authState) {
    return <Navigate to="/login" />;
  }

  return <React.Fragment>{props.children}</React.Fragment>;
};

export default AuthProtected;
